import script from "./StockFinancialView.vue?vue&type=script&setup=true&lang=js"
export * from "./StockFinancialView.vue?vue&type=script&setup=true&lang=js"

import "./StockFinancialView.vue?vue&type=style&index=0&id=51928645&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51928645"]])

export default __exports__